import { render, staticRenderFns } from "./FeedView.vue?vue&type=template&id=599864ca&scoped=true&"
import script from "./FeedView.vue?vue&type=script&lang=js&"
export * from "./FeedView.vue?vue&type=script&lang=js&"
import style0 from "./FeedView.vue?vue&type=style&index=0&id=599864ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599864ca",
  null
  
)

export default component.exports